var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "warp" },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "auto" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-descriptions",
                { attrs: { colon: false, column: 3, direction: "vertical" } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.RecipientName") } },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": "receiveName",
                          "encrypted-value": _vm.receiverInfo.receiveName,
                          label: _vm.$t("newOrder.RecipientName"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.RecipientCompany") } },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": "receiveCompany",
                          "encrypted-value": _vm.receiverInfo.receiveCompany,
                          label: _vm.$t("newOrder.RecipientCompany"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.Recipientphone") } },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": "receiveMobile",
                          "encrypted-value": _vm.receiverInfo.receiveMobile,
                          label: _vm.$t("newOrder.Recipientphone"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.Street1") } },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.receiverInfo.receiveStreet || "--")),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.doorNumber") } },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.receiverInfo.receiveHouseNumber || "--")
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.RecipientDistrict") } },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.receiverInfo.receiveArea || "--")),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.RecipientCity") } },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.receiverInfo.receiveCity || "--")),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.RecipientState") } },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.receiverInfo.receiveState || "--")),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.RecipientZipCode") } },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.receiverInfo.receiveZipcode || "--")),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions",
                { attrs: { colon: false, column: 1, direction: "vertical" } },
                [
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: _vm.$t("GlobalSetObj.recipientComplement"),
                      },
                    },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": "receiveComplement",
                          "encrypted-value": _vm.receiverInfo.receiveComplement,
                          label: _vm.$t("GlobalSetObj.recipientComplement"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions",
                { attrs: { colon: false, column: 3, direction: "vertical" } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.RecipientCPFCNPJ") } },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": "receiveTax",
                          "encrypted-value": _vm.receiverInfo.receiveTax,
                          label: _vm.$t("newOrder.RecipientCPFCNPJ"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "GlobalSetObj.NationalRegistrationNumber"
                        ),
                      },
                    },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.receiverInfo.receiveIeNumber || "--")
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions",
                { attrs: { colon: false, column: 1, direction: "vertical" } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.ReceivingAddress") } },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": "receiveAddress",
                          "encrypted-value": _vm.receiverInfo.receiveAddress,
                          label: _vm.$t("newOrder.ReceivingAddress"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions",
                { attrs: { colon: false, column: 3, direction: "vertical" } },
                [
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: { label: _vm.$t("newOrder.Recipientphonenumber") },
                    },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": _vm.receiverInfo.receivePhone
                            ? "receivePhone"
                            : "receiveMobile",
                          "encrypted-value": _vm.receiverInfo.receivePhone
                            ? _vm.receiverInfo.receivePhone
                            : _vm.receiverInfo.receiveMobile,
                          label: _vm.$t("newOrder.Recipientphonenumber"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.RecipientEmail") } },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": "receiveMail",
                          "encrypted-value": _vm.receiverInfo.receiveMail,
                          label: _vm.$t("newOrder.RecipientEmail"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }